import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LocaleString } from '@/api-client/models/utilization/Contracts'
import TableBasicTextLoader from '@/design-system/atoms/TableBasicTextLoader.vue'
import { computed, toRefs } from 'vue'
import { useDataSources } from '@/composables/useDataSources'
import { useI18n } from 'vue-i18n'
import { FormatOptions, formatter } from '../formatter'

export type Cell =
  | { type: 'data-source'; dataSource: string; format?: FormatOptions }
  | { type: 'text'; text: LocaleString }
  | { type: 'number'; number?: number; isLoading?: boolean; format?: FormatOptions }

export type Table = {
  sort?: { col: number; direction: 'asc' | 'desc'; field: string }
  caption?: LocaleString
  headers: LocaleString[]
  rows: Cell[][]
}

type Props = {
  table: Table
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TableDataSource',
  props: {
    table: {}
  },
  setup(__props: any) {

const props = __props

const { locale } = useI18n()
const { dataSources } = toRefs(useDataSources())

const sortBy =
  (col: number, field: string) =>
  (i: number): string => {
    return props.table.rows?.[i]?.[col]?.[field] ?? '?'
  }

const tableTransformed = computed(() => {
  return {
    headers: props.table.headers.map((header) => {
      return {
        text: header[locale.value]
      }
    }),
    rows: props.table.rows.map((row) => {
      return row.map((cell) => {
        if (cell.type === 'text') {
          return {
            text: cell.text[locale.value]
          }
        } else if (cell.type === 'number') {
          return {
            text: formatter(cell.number, locale.value, cell.format),
            isLoading: cell.isLoading ?? true
          }
        } else if (cell.type === 'data-source') {
          return {
            text: formatter(
              dataSources.value[cell.dataSource]?.data as number | string,
              locale.value,
              cell.format
            ),
            isLoading: dataSources.value[cell.dataSource]?.isLoading ?? true
          }
        }
        // @ts-ignore
        throw new Error(`Unknown cell type ${cell.type}`)
      })
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TableBasicTextLoader, {
    table: tableTransformed.value,
    sortBy: _ctx.table.sort ? sortBy(_ctx.table.sort?.col, _ctx.table.sort?.field) : undefined,
    direction: _ctx.table.sort?.direction,
    caption: _ctx.table.caption?.[_unref(locale)] ?? ''
  }, null, 8, ["table", "sortBy", "direction", "caption"]))
}
}

})